var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"outlined":"","hide-details":"","dense":"","disabled":_vm.disabled,"value":_vm.value,"items":_vm.items,"item-text":"label","item-value":"value","return-object":true,"append-icon":""},on:{"input":(v) => _vm.onInput(v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }